import { Option } from "src/app/shared/models/option.interface";

export const DATES_OPTIONS: Option[] = [
    {
      name: 'All Date',
      key: 'all_date',
    },
    {
      name: '12 Months',
      key: '12_months',
    },
    {
      name: '30 Days',
      key: '30_days',
    },
    {
      name: '7 Days',
      key: '7_days',
    },
    {
      name: '24 Hours',
      key: '24_hours',
    },
  ];